export default __webpack_public_path__ + "images/0ffba0d9cba153065a0c88cd5573f6dd-blobCurve.png";